import { render, staticRenderFns } from "./SitePlanCard.vue?vue&type=template&id=85c565b6&scoped=true"
import script from "./SitePlanCard.vue?vue&type=script&lang=js"
export * from "./SitePlanCard.vue?vue&type=script&lang=js"
import style0 from "./SitePlanCard.vue?vue&type=style&index=0&id=85c565b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c565b6",
  null
  
)

export default component.exports